import { gql } from "@apollo/client"

import imageFields from "./partials/imageFields"
import seoFields from "./partials/seoFields"
import sys from "./partials/sys"

export const blogPostsId = "5TRvCsbznpz60Fh6VlnsFa"
export const blogPostsCollection = `contentType${blogPostsId}Collection`
export const categoriesCollection =
  "contentType5LsBa6D2Ygf1G6Unb67HsLCollection"

export const BlogPostFields = `
  title
  date
  slug
  categoriesCollection {
    items {
      sys {
        id
      }
      name
    }
  }
  authorsCollection(limit: 3) {
    items {
      firstName
      lastName
    }
  }
  seo {
    ${seoFields}
  }
  sys {
    id
  }
`

export const GET_VIDEO_LIST_QUERY = gql`
  query GetVideosById($id: String!) {
    listVideosCollection(where: { sys: { id: $id } }, limit: 1) {
      items {
        videosListCollection {
          total
          items {
            _id
            videoLink
            videoName
            videoCover {
              url
            }
            wistiaVideo
          }
        }
      }
    }
  }
`

export const GET_ALL_CATEGORIES_QUERY = gql`
  query InsightsCategories {
    ${categoriesCollection} {
      items {
        name
        slug
        metaTitle
        description
      }
    }
  }
`

export const GET_ALL_BLOG_POST_SLUGS_QUERY = gql`
  query InsightsPostsSlugs {
    ${blogPostsCollection} {
      total
      items {
        slug
      }
    }
  }
`

// The GraphQL query
export const BLOG_POSTS_QUERY = gql`
  query InsightsPage ($skip: Int!, $category: String) {
    allCategories: ${categoriesCollection} {
      items {
        name
        slug
      }
    }
    allBlogPosts: ${blogPostsCollection}(
        order: date_DESC
        limit: 9
        skip: $skip
        where: {
          categories: {
            slug: $category
          }
        }
        ) {
      total
      items {
        ${BlogPostFields}
      }
    }
    featuredPosts: ${blogPostsCollection}(
        order: date_DESC
        limit: 2
        skip: 0
        where: {
          categories: {
            sys: {
              id: "5K8Zc59MvKdJmUWJNqIvNu"
            }
          }
        }
      ) {
      items{
        ${BlogPostFields}
      }
    }
    trendingPosts: ${blogPostsCollection}(
      order: date_DESC
      limit: 6
      skip: 0
    ) {
      items{
          ${BlogPostFields}
      }
    }
  }
`

// TO DO: make all slugs either have a trailing slash or not have a trailing slash

export const GET_INDIVIDUAL_BLOG_POST = gql`
  query GetBlogPost($slug: String!, $preview: Boolean!) {
    ${blogPostsCollection} (
      where: { slug: $slug }
      preview: $preview
      limit: 1
    )  {
        items {
          ${sys}
          title
          date
          authorsCollection(limit: 3){
            items{
              firstName
              lastName
            }
          }
          contentRich {
            json
            links {
              entries {
                inline {
                  ${sys}
                  __typename
                  ... on Videos {
                    videoName
                    videoLink
                    videoCover{
                      url
                    }
                    wistiaVideo
                    popover
                  }
                }
                block {
                  ${sys}
                  __typename
                  ... on Videos {
                    videoName
                    videoLink
                    videoCover{
                      url
                    }
                    wistiaVideo
                    popover
                  }
                }
              }
              assets {
                block {
                  ${imageFields}
                }
              }
            }
          }
          content
          slug
          categoriesCollection{
            items{
              name
              slug
            }
          }
          seo {
            ${seoFields}
          }
        }
      }
    }
`
export const LATEST_BLOGS_QUERY = gql`
  query InsightsPage ($limit: Int) {
    allBlogPosts: ${blogPostsCollection}(
        order: date_DESC
        limit: $limit
     ) {
      total
      items {
        ${sys}
        title
        date
        slug
        seo {
          ${seoFields}
        }
      }
    }
  }
`
/**
 * Represents a system-generated identifier object in Contentful.
 */
export interface SysId {
  __typename?: "Sys"
  id: string
}

/**
 * Represents an image asset from Contentful.
 */
export interface ContentfulImage {
  __typename?: "Asset"
  sys: SysId
  url: string
  title: string
  width: number
  height: number
  description: string
  contentType: string
}

/**
 * Represents the SEO metadata for a blog post.
 */
export interface SeoData {
  __typename?: "Seo"
  seoTitle: string
  seoDescription: string
  ogTitle: string | null
  ogDescription: string | null
  ogImage: ContentfulImage | null
  featuredImage: ContentfulImage | null
  hidePageFromSearchEnginesNoIndex: boolean
  excludeLinksFromSearchRankingsNofollow: boolean
  canonicalUrl: string | null
}

/**
 * Represents a single blog post item from the collection.
 */
export interface BlogPostItem {
  __typename?: "ContentType5TRvCsbznpz60Fh6VlnsFa" // This is Contentful's content type name
  sys: SysId
  title: string
  date: string // Can be parsed into a Date object: new Date(date)
  slug: string
  seo: SeoData | null
}

/**
 * Represents the top-level query variables for the InsightsPage query.
 */
export interface InsightsPageQueryVariables {
  limit?: number | null
}

/**
 * Represents the entire response shape for the InsightsPage GraphQL query.
 */
export interface InsightsPageQuery {
  allBlogPosts: {
    __typename?: "ContentType5TRvCsbznpz60Fh6VlnsFaCollection"
    total: number
    limit: number
    items: BlogPostItem[]
  }
}
